module.exports = __webpack_public_path__ + "media/images/workplace/patterns/2-1630d138fb5cad8dcf7202479aafe65f.png";